<template>
  <div>
    <h4>Privacy Policy</h4>
    <privacy />
  </div>
</template>

<script>
    import Privacy from "@/components/Guest/Privacy.vue";
    export default {
        components: {
            Privacy
        }
    }
</script>

